var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cancel"},[_c('div',{staticClass:"cancel-top"},[_c('div',{staticClass:"cancel-top_core"},[_c('img',{staticClass:"icon",attrs:{"src":require("../../../assets/images/result/Upset.png")}}),_c('div',{staticClass:"msg",attrs:{"bold":""}},[_vm._v(_vm._s(_vm.$t('fullDinein.cancelMsg')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }